export enum InquiryStatusType {
    NEW = 1,
    CALL_MADE = 2,
    DOCUMENTATION_WAITING = 3,
    DOCUMENTATION_RECIVED = 4,
    CANCELED = 7,
    RESERVATION_DONE = 8,
    FINISHED = 9,
}
